import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import CheckIcon from "@mui/icons-material/Check";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import DoNotDisturbAltOutlinedIcon from "@mui/icons-material/DoNotDisturbAltOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ErrorIcon from "@mui/icons-material/Error";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import InfoIcon from "@mui/icons-material/Info";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PageviewIcon from "@mui/icons-material/Pageview";
import HistoryIcon from "@mui/icons-material/History";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RemoveIcon from "@mui/icons-material/Remove";
import SearchIcon from "@mui/icons-material/Search";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import CircularProgress from "@mui/material/CircularProgress";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import PropTypes from "prop-types";
import { forwardRef } from "react";
import "@/components/SiteIcons/SiteIcons.css";

const SiteIcons = forwardRef((props, ref) => {
  const { iconstring, color = "", page = "" } = props;
  const classString = `${color} ${page}`;
  props = { ...props, className: classString, ref };

  if (iconstring === "check") {
    return <CheckCircleIcon {...props} />;
  } else if (iconstring === "checkoutline") {
    return <CheckCircleOutlineIcon {...props} />;
  } else if (iconstring === "cloud-upload") {
    return <CloudUploadIcon {...props} />;
  } else if (iconstring === "download") {
    return <DownloadIcon {...props} />;
  } else if (iconstring === "delete") {
    return <DeleteIcon {...props} />;
  } else if (iconstring === "expand-less") {
    return <ExpandLess {...props} />;
  } else if (iconstring === "expand-more") {
    return <ExpandMore {...props} />;
  } else if (iconstring === "info") {
    return <InfoIcon {...props} />;
  } else if (iconstring === "search") {
    return <SearchIcon {...props} />;
  } else if (iconstring === "clear") {
    return <ClearIcon {...props} />;
  } else if (iconstring === "error") {
    return <ErrorIcon {...props} />;
  } else if (iconstring === "erroroutline") {
    return <ErrorOutlineIcon {...props} />;
  } else if (iconstring === "arrow-forward") {
    return <ArrowForwardIosIcon {...props} />;
  } else if (iconstring === "arrow-back") {
    return <ArrowBackIosNewIcon {...props} />;
  } else if (iconstring === "arrow-right") {
    return <KeyboardArrowRightIcon {...props} />;
  } else if (iconstring === "arrow-down") {
    return <KeyboardArrowDownIcon {...props} />;
  } else if (iconstring === "edit") {
    return <EditIcon {...props} />;
  } else if (iconstring === "description") {
    return <DescriptionIcon {...props} />;
  } else if (iconstring === "hourglass") {
    return <HourglassEmptyOutlinedIcon {...props} />;
  } else if (iconstring === "check-outline") {
    return <CheckOutlinedIcon {...props} />;
  } else if (iconstring === "close") {
    return <CloseIcon {...props} />;
  } else if (iconstring === "delete-outlined") {
    return <DeleteOutlineOutlinedIcon {...props} />;
  } else if (iconstring === "edit-outlined") {
    return <EditOutlinedIcon {...props} />;
  } else if (iconstring === "circular-loader") {
    return <CircularProgress {...props} />;
  } else if (iconstring === "radio-button-checked") {
    return <RadioButtonCheckedIcon {...props} />;
  } else if (iconstring === "circle") {
    return <Brightness1Icon {...props} />;
  } else if (iconstring === "add") {
    return <AddIcon {...props} />;
  } else if (iconstring === "remove") {
    return <RemoveIcon {...props} />;
  } else if (iconstring === "swapVert") {
    return <SwapVertIcon {...props} />;
  } else if (iconstring === "view-summary") {
    return <PageviewIcon {...props} />;
  } else if (iconstring === "excluded") {
    return <DoNotDisturbAltOutlinedIcon {...props} />;
  } else if (iconstring === "copy") {
    return <ContentCopyIcon {...props} />;
  } else if (iconstring === "basicCheck") {
    return <CheckIcon {...props} />;
  } else if (iconstring === "history") {
    return <HistoryIcon {...props} />;
  } else if (iconstring === "pending") {
    return <PendingOutlinedIcon {...props} />;
  }
});
SiteIcons.displayName = "SiteIcons";

SiteIcons.propTypes = {
  iconstring: PropTypes.string,
  color: PropTypes.string,
  page: PropTypes.string,
};

export default SiteIcons;
